import React from 'react';
import MenuSection from './source/MenuSection'
import { useFilterMenu } from './hooks/useFilterMenu'
import { Grid } from '@mui/material'; 
import { SLUGS } from 'src/enum/permissions.enum';

const FACILITY_MENU = {
  settings: [
    { check: SLUGS.FACILITY.UPDATE, to: '/edit', primary: 'Изменить параметры' },
    { check: SLUGS.PROJECT.ROOT.CREATE, to: '/add', primary: 'Добавить проект' },
    { check: SLUGS.FACILITY.ACCESS.READ, to: '/access', primary: 'Доступ пользователей' },
  ],
  docs: [
    { check: SLUGS.FACILITY.FORM_KS3.READ, to: '/form/ks3', primary: 'КС3' },
    { check: SLUGS.FACILITY.FILES.READ, to: '/files', primary: 'Файлы' },
  ],
  directory: [
    { check: SLUGS.FACILITY.RESP_PERSON.READ, to: '/responsible', primary: 'Представители ответственных лиц' },
    { check: SLUGS.FACILITY.MACHINE.READ, to: '/machine', primary: 'Техника' },
  ],
}
const FACILITY_SECTION = {
  settings: 'Настройки',
  docs: 'Документы',
  directory: 'Справочники',
}

export default function FacilityMenu(props) {
  const idFacility = props.match?.params?.id;
  const filteredMenu = useFilterMenu(FACILITY_MENU);
  const orderedKeys = Object.keys(FACILITY_SECTION);
  const facilityPath = (typeof idFacility !== 'undefined') ? `/facility/${idFacility}` : ''
  return (
    <Grid container spacing={2}>
      {Object.entries(filteredMenu).sort(([keyA], [keyB]) => {
      return orderedKeys.indexOf(keyA) - orderedKeys.indexOf(keyB);
    }).map(([key, items]) => {
        const sectionName = FACILITY_SECTION[key] || key;
        return (
          <MenuSection
            key={key}
            arr={items.map(e=>({...e, to: facilityPath+e.to}))}
            name={sectionName}
          />
        );
      })}
    </Grid>
  );
}